

export const GENERAL_LOADER_UPDATE_DATA = 'GENERAL_LOADER:UPDATE_DATA';
export const GENERAL_LOADER_CLEAR_DATA = 'GENERAL_LOADER:CLEAR_DATA';